// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"194": "__federation_expose_ScribeSettings","615": "__federation_expose_Scribe",}[chunkId] + "." + {"194": "7d7367bd","615": "9783578b",}[chunkId] + ".css"
}